import Highcharts from "highcharts";
import hcMore from "highcharts/highcharts-more";
import React from "react";
import { InsHighcharts } from "../../base/insHighcharts";
import "./insRadarChart.scss";
import { useGetBenchmarkFooter } from "../base/utils";
import { InsQueryStatedElement } from "components/widgets/base/insQueryStatedElement";
import { useWidgetComponentProps } from "components/widgets/hooks/use-current-widget";
import { useGetDatapointsWidgetData } from "hooks/widget-data/use-datapoints";
hcMore(Highcharts);
export const InsRadarChart = (props) => {
    const { sectionId, widgetId } = props, widgetProps = useWidgetComponentProps(sectionId, widgetId);
    const [[response], queryState, refresh] = useGetDatapointsWidgetData(props);
    const data = response?.data ?? [];
    const mergeTooltips = (value) => data.filter((d) => d.rankBasedValue === value).map((d) => d.tooltip);
    const options = {
        chart: {
            className: "highcharts-radar-chart",
            polar: true,
            styledMode: true,
            type: "line"
        },
        credits: { enabled: false },
        legend: {
            enabled: false
        },
        series: [
            {
                data: data.map((d) => d.rankBasedValue),
                name: "Performance",
                pointPlacement: "on",
                type: "line"
            }
        ],
        subtitle: {
            align: "left",
            text: useGetBenchmarkFooter(widgetProps.subtitle, response?.additionalData),
            verticalAlign: "bottom",
            x: -8
        },
        title: {
            text: ""
        },
        tooltip: {
            formatter() {
                const value = this.point.y;
                const { category } = this.point;
                /*
                 *  For now only merge tooltips for points with value 0
                 *  Later we will refine the max distance where merging applies
                 */
                if (value === 0) {
                    return mergeTooltips(value);
                }
                return data.filter((d) => d.category === category)[0].tooltip;
            }
        },
        xAxis: {
            categories: data.map((d) => d.category),
            tickmarkPlacement: "on"
        },
        yAxis: {
            gridLineInterpolation: "polygon",
            labels: {
                enabled: false
            },
            max: 4,
            min: 0,
            plotBands: [
                {
                    className: "quartile-ranking-bottom",
                    from: 0,
                    to: 1
                },
                {
                    className: "quartile-ranking-lower-mid",
                    from: 1,
                    to: 2
                },
                {
                    className: "quartile-ranking-upper-mid",
                    from: 2,
                    to: 3
                },
                {
                    className: "quartile-ranking-top",
                    from: 3,
                    to: 4
                }
            ],
            tickInterval: 1
        }
    };
    return React.createElement(InsQueryStatedElement, { widgetFactoryProps: props, queryState: queryState, hasData: data.length > 0 },
        React.createElement(InsHighcharts, { key: `${sectionId}-${widgetId}-${props.index}`, options: options, colorSet: widgetProps.colorSet, sectionId: sectionId, widgetId: widgetId, refreshAction: refresh, isMaximizedOne: props.isMaximizedOne }));
};
